import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import { InfoOutlined } from '@material-ui/icons';
import ScheduleIcon from '@material-ui/icons/Schedule';
import DeleteIcon from '@material-ui/icons/Delete';
import { func, number, bool, shape, string } from 'prop-types';

import cx from 'classnames';
import styles from './styles.scss';

export default class RuleItem extends Component {
  static propTypes = {
    onChangeStartTime: func,
    index: number,
    onChangeEndTime: func,
    onRemoveItem: func,
    onChangeValue: func,
    rule: shape({
      check: bool,
      checkCompare: bool,
      value: number,
      start: string,
      end: string
    }),
    isDisable: bool,
    inAdvertiserTab: bool,
    appConfigRules: bool,
    timeErrorMessage: string,
    overlapErrorMessage: string
  };

  static defaultProps = {
    timeErrorMessage: 'Start time cannot be equal to or greater than the end time.',
    overlapErrorMessage: 'Custom timespan cannot overlap'
  };

  handleOnChangeStart = event => {
    const { onChangeStartTime, index } = this.props;
    const value = event.target.value;
    onChangeStartTime && onChangeStartTime(value, index);
  };

  handleOnChangeEnd = event => {
    const { onChangeEndTime, index } = this.props;
    const value = event.target.value;
    onChangeEndTime && onChangeEndTime(value, index);
  };

  removeItem = () => {
    const { onRemoveItem, index } = this.props;
    onRemoveItem && onRemoveItem(index);
  };

  handleOnChangeValue = event => {
    const { onChangeValue, index } = this.props;
    let value = parseInt(event.target.value);
    value = Math.max(1, Math.min(60, value));
    onChangeValue && onChangeValue(value, index);
  };

  // triggered when the input loses focus, purpose re-validate and set default value.
  handleOnInputBlur = event => {
    // user clear input or any NaN value, it should set a default value 8
    let value = parseInt(event.target.value) || 8;
    value = Math.max(1, Math.min(60, value));
    const { onChangeValue, index } = this.props;

    onChangeValue && onChangeValue(value, index);
    // Update the input field to reflect the clamped value
    event.target.value = value;
  };

  render() {
    const { rule, isDisable, inAdvertiserTab, appConfigRules, timeErrorMessage, overlapErrorMessage } = this.props;
    const hasError = !rule.check ? 'error' : '';
    return (
      <div>
        <div
          className={
            inAdvertiserTab
              ? styles.itemAdvertiserTab
              : styles.itemAdminSettings
          }
        >
          <div className={styles.ruleItemGroup}>
            <div>
              {rule.check ? (
                <ScheduleIcon className={cx(styles[hasError])} />
              ) : (
                <InfoOutlined className={styles[hasError]} />
              )}
            </div>
            <div>
              <TextField
                type="time"
                value={rule.start}
                inputProps={{
                  step: 300 // 5 min
                }}
                className={cx(styles.inputDate, styles[hasError])}
                onChange={this.handleOnChangeStart}
                disabled={isDisable && inAdvertiserTab}
              />
            </div>
            <div>
              <span>To</span>
            </div>
            <div>
              <TextField
                type="time"
                value={rule.end}
                inputProps={{
                  step: 300 // 5 min
                }}
                className={cx(styles.inputDate, styles[hasError])}
                onChange={this.handleOnChangeEnd}
                disabled={isDisable && inAdvertiserTab}
              />
            </div>
            <div>
              <TextField
                type="number"
                value={rule.value}
                inputProps={{ min: 1, max: 60, step: 1 }} // Optional, for spin button behavior
                className={styles.inputDate}
                disabled={
                  (isDisable && inAdvertiserTab) ||
                  (!rule.check && appConfigRules)
                }
                onChange={this.handleOnChangeValue}
                onBlur={this.handleOnInputBlur}
              />
            </div>
            <div>
              <span>Minutes</span>
            </div>
            {!isDisable && (
              <div>
                <IconButton onClick={this.removeItem}>
                  <DeleteIcon />
                </IconButton>
              </div>
            )}
          </div>
          <div className={styles.alert}>
            {!rule.checkCompare && <span>{timeErrorMessage}</span>}
          </div>
          <div className={styles.alert}>
            {!rule.check && rule.checkCompare && <span>{overlapErrorMessage}</span>}
          </div>
        </div>
      </div>
    );
  }
}
